import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import DocumentViewController from "../../redux/actions/DocumentApiAction";
import "../../styles/styles.css";
import "../../styles/layout.css";
import ExperienceLetterDialog from "./ExperianceLetterDailog";
import RelievingLetterDialog from "./RelievingLetterDailog";
import InternshipLetterDialog from "./InternshipLetterDailog";

const DocumentList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  // Actions
  const { getEmployeeForGenrateDocument,getInternshipLetter,getRelievingLetter,getExperianceLetter,
        getJoiningLetter
  } = DocumentViewController();

  // Redux state
  const {all_employee } = useSelector((state) => state.document);

  // Filters
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedRows, setSelectedRows] = useState([]);

  const [expDialogOpen, setExpDialogOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [relDialogOpen, setRelDialogOpen] = useState(false);
  const [relEmployee, setRelEmployee] = useState(null);

  const [internDialogOpen, setInternDialogOpen] = useState(false);
  const [internEmployee, setInternEmployee] = useState(null);

console.log('Relieving action URL test:',
  getRelievingLetter.toString());

  // Fetch employees on mount
  useEffect(() => {
    dispatch(getEmployeeForGenrateDocument());
  }, []);

  // Filter employees based on is_active status
  const filteredEmployees =
    selectedStatus === "all"
      ? all_employee
      : all_employee?.filter((e) =>
          selectedStatus === "active" ? e.is_active : !e.is_active
        );

  // Grid columns
  const columnDefs = [
  {
    headerCheckboxSelection: true,
    checkboxSelection: true,
    maxWidth: 50,
    pinned: "left",
  },
  {
    headerName: "SR.No",
    valueGetter: (params) => params.node.rowIndex + 1,
    maxWidth: 80,
  },
  { headerName: "Employee ID", field: "employee_id", flex: 0.8 },
  { headerName: "Name", valueGetter: p => `${p.data.first_name} ${p.data.last_name}` },
 {
      headerName: "Internship",
      flex: 1.2,
      cellRenderer: (params) => (
        <Tooltip title="Download Internship Letter">
          <IconButton
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              setInternEmployee(params.data);
              setInternDialogOpen(true);
            }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  {
  headerName: "Joining Letter",
  flex: 1.5,
  cellRenderer: (params) => (
    <Tooltip title="Download Joining Letter">
      <IconButton
        color="primary"
        onClick={(e) => {
          e.stopPropagation(); // Prevent row click
          const { id, first_name, last_name } = params.data;
          dispatch(getJoiningLetter(id, first_name, last_name));
        }}
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  ),
},
 {
  headerName: "Relieving",
  flex: 1.5,
  cellRenderer: (params) => (
    <Tooltip title="Download Relieving Letter">
      <IconButton
        color="primary"
        onClick={(e) => {
          e.stopPropagation();           // ⬅️ prevent ag-Grid row click
          setRelEmployee(params.data);
          setRelDialogOpen(true);
        }}
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  ),
},


  {
  headerName: "Experience",
  flex: 1.5,
  cellRenderer: (params) => (
    <Tooltip title="Download Experience Letter">
      <IconButton
        color="primary"
        onClick={() => {
          setSelectedEmployee(params.data);
          setExpDialogOpen(true);
        }}
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  ),
}

];


  return (
    <div>
      {/* Export button */}
      <div className="d-flex justify-content-between mb-2">
        {selectedRows.length > 0 ? (
          <ExportButton
            gridRef={gridRef}
            selectedRows={selectedRows}
            fileName={`Employees_${new Date().toISOString().slice(0, 10)}.csv`}
            exportColumns={[
              "employee_id",
              "first_name",
              "last_name",
              "email",
              "mobile_number",
              "gender",
              "is_active",
            ]}
          />
        ) : (
          <div />
        )}
      </div>

      {/* Filters + Title */}
      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Employee Documents</h3>
          </Col> 
        </Row>
      </div>

      {/* Grid */}
      <div className="list-grid-container" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={filteredEmployees}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

     <ExperienceLetterDialog
  open={expDialogOpen}
  onClose={() => setExpDialogOpen(false)}
  employee={selectedEmployee}
  onSubmit={(employee, formData) => {
    if (!employee) return;
    const { id, first_name, last_name } = employee;
    dispatch(
      getExperianceLetter(id, first_name, last_name, {
        end_date: formData.end_date,
        supervisor_name: formData.supervisor_name,
        supervisor_position: formData.supervisor_position,
      })
    );
    setExpDialogOpen(false);
  }}
/>

<RelievingLetterDialog
  open={relDialogOpen}
  onClose={() => setRelDialogOpen(false)}
  employee={relEmployee}
  onSubmit={(employee, formData) => {
    if (!employee) return;
    const { id, first_name, last_name } = employee;
    dispatch(
      getRelievingLetter(id, first_name, last_name, {
        closing_date: formData.closing_date,
        supervisor_name: formData.supervisor_name,
        designation: formData.designation,
      })
    );
    setRelDialogOpen(false);
  }}
/>
 <InternshipLetterDialog
  open={internDialogOpen}
  onClose={() => setInternDialogOpen(false)}
  employee={internEmployee}
  onSubmit={(employee, formData) => {
    if (!employee) return;
    const { id, first_name, last_name } = employee;
    dispatch(
      getInternshipLetter(id, first_name, last_name, {
        joining_date: formData.joining_date,
        ending_date: formData.ending_date,
        employment_type: formData.employment_type,
        designation: formData.designation,
        shift_time: formData.shift_time,
        working_days: formData.working_days,
        stipend: formData.stipend,
        supervisor_name: formData.supervisor_name,            // ✅ NEW
        supervisor_designation: formData.supervisor_designation, // ✅ NEW
      })
    );
    setInternDialogOpen(false);
  }}
/>


    </div>
  );
};

export default DocumentList;
